// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#forgot-password-modal {
  z-index: 1400;
}
#forgot-password-modal .modal-content {
  border: 1px solid var(--gray-80);
  max-width: 468px;
}
@media screen and (max-width: 575.98px) {
  #forgot-password-modal .modal-content {
    max-width: 100%;
    overflow: hidden;
  }
}
#forgot-password-modal .modal-content .btn-close {
  border-radius: 100%;
  background: var(--gray-80);
  opacity: 1 !important;
  top: 1.75rem !important;
  right: 1.5rem !important;
}
@media screen and (max-width: 575.98px) {
  #forgot-password-modal .modal-content .btn-close {
    background: transparent !important;
    border: none !important;
  }
  #forgot-password-modal .modal-content .btn-close svg {
    height: 1rem;
    width: 1rem;
  }
  #forgot-password-modal .modal-content .btn-close svg path {
    fill: var(--gray-40);
  }
}
#forgot-password-modal .modal-body {
  padding: 1.5rem !important;
}
@media screen and (max-width: 575.98px) {
  #forgot-password-modal .modal-body {
    background-color: var(--gray-85) !important;
    padding: 0 !important;
  }
}
#forgot-password-modal .modal-body .heading-text {
  font-weight: 700;
  font-size: 20px;
}
@media screen and (max-width: 575.98px) {
  #forgot-password-modal .modal-body .heading-text {
    padding: 1.5rem !important;
    border-bottom: 1px solid var(--gray-80);
  }
}
#forgot-password-modal .modal-body .input-note {
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--gray-40);
  margin-bottom: 1.5rem;
  margin-top: 0.5rem;
  line-height: 0.75rem;
}
#forgot-password-modal .modal-body .auth-btn {
  border: 1px solid var(--blue-300);
  background: transparent;
  color: var(--blue-50);
}
@media screen and (max-width: 575.98px) {
  #forgot-password-modal .modal-dialog {
    position: fixed;
    top: auto;
    right: auto;
    left: auto;
    bottom: 0;
    width: 100%;
    margin: 0;
  }
  #forgot-password-modal .modal-dialog-centered {
    min-height: auto;
  }
  #forgot-password-modal .forgot-pass-btn-wrap {
    flex-direction: column;
  }
  #forgot-password-modal .forgot-pass-btn-wrap button {
    width: 100%;
  }
  #forgot-password-modal form {
    padding: 0 1.5rem 1.5rem 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Popups/ForgotPasswordPopup/forgotPassword.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,gCAAA;EACA,gBAAA;AACJ;AAAI;EAHF;IAII,eAAA;IACA,gBAAA;EAGJ;AACF;AADI;EACE,mBAAA;EACA,0BAAA;EACA,qBAAA;EACA,uBAAA;EACA,wBAAA;AAGN;AAFM;EANF;IAOI,kCAAA;IACA,uBAAA;EAKN;EAJM;IACE,YAAA;IACA,WAAA;EAMR;EAJQ;IACE,oBAAA;EAMV;AACF;AAAE;EACE,0BAAA;AAEJ;AADI;EAFF;IAGI,2CAAA;IACA,qBAAA;EAIJ;AACF;AAFI;EACE,gBAAA;EACA,eAAA;AAIN;AAHM;EAHF;IAII,0BAAA;IACA,uCAAA;EAMN;AACF;AAHI;EACE,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;AAKN;AAFI;EACE,iCAAA;EACA,uBAAA;EACA,qBAAA;AAIN;AAMI;EADF;IAEI,eAAA;IACA,SAAA;IACA,WAAA;IACA,UAAA;IACA,SAAA;IACA,WAAA;IACA,SAAA;EAHJ;EAOA;IAEI,gBAAA;EAJJ;EAQA;IAEI,sBAAA;EALJ;EAMI;IACE,WAAA;EAJN;EASA;IAEI,+BAAA;EANJ;AAjBF","sourcesContent":["#forgot-password-modal {\n  z-index: 1400;\n\n  .modal-content {\n    border: 1px solid var(--gray-80);\n    max-width: 468px;\n    @media screen and (max-width: 575.98px) {\n      max-width: 100%;\n      overflow: hidden;\n    }\n\n    .btn-close {\n      border-radius: 100%;\n      background: var(--gray-80);\n      opacity: 1 !important;\n      top: 1.75rem !important;\n      right: 1.5rem !important;\n      @media screen and (max-width: 575.98px) {\n        background: transparent !important;\n        border: none !important;\n        svg {\n          height: 1rem;\n          width: 1rem;\n\n          path {\n            fill: var(--gray-40);\n          }\n        }\n      }\n    }\n  }\n\n  .modal-body {\n    padding: 1.5rem !important;\n    @media screen and (max-width: 575.98px) {\n      background-color: var(--gray-85) !important;\n      padding: 0 !important;\n    }\n\n    .heading-text {\n      font-weight: 700;\n      font-size: 20px;\n      @media screen and (max-width: 575.98px) {\n        padding: 1.5rem !important;\n        border-bottom: 1px solid var(--gray-80);\n      }\n    }\n\n    .input-note {\n      font-size: 0.875rem;\n      font-weight: 400;\n      color: var(--gray-40);\n      margin-bottom: 1.5rem;\n      margin-top: 0.5rem;\n      line-height: 0.75rem;\n    }\n\n    .auth-btn {\n      border: 1px solid var(--blue-300);\n      background: transparent;\n      color: var(--blue-50);\n\n      // &:hover {\n      //   background: transparent !important;\n      //   color: var(--blue-50);\n      // }\n    }\n  }\n\n  .modal-dialog {\n    @media screen and (max-width: 575.98px) {\n      position: fixed;\n      top: auto;\n      right: auto;\n      left: auto;\n      bottom: 0;\n      width: 100%;\n      margin: 0;\n    }\n  }\n\n  .modal-dialog-centered {\n    @media screen and (max-width: 575.98px) {\n      min-height: auto;\n    }\n  }\n\n  .forgot-pass-btn-wrap {\n    @media screen and (max-width: 575.98px) {\n      flex-direction: column;\n      button {\n        width: 100%;\n      }\n    }\n  }\n\n  form {\n    @media screen and (max-width: 575.98px) {\n      padding: 0 1.5rem 1.5rem 1.5rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
